import { Pipe, PipeTransform } from "@angular/core";
import { LocalizationService } from "@abp/localization/localization.service";
import { AppConsts } from "@shared/AppConsts";

@Pipe({
  name: "translate",
})
export class TranslatePipe implements PipeTransform {
  localizationSourceName = AppConsts.localization.defaultLocalizationSourceName;

  constructor(private localizationService: LocalizationService) {}

  transform(key: any, ...args: any[]): any {
    args.unshift(key);
    args.unshift(this.localizationSourceName);
    return this.ls.apply(this, args);
  }

  ls(sourcename: string, key: string, ...args: any[]): string {
    let localizedText = this.localizationService.localize(key, sourcename);

    if (!localizedText) {
      localizedText = key;
    }

    if (!args || !args.length) {
      return localizedText;
    }

    args.unshift(localizedText);
    return abp.utils.formatString.apply(this, args);
  }
}
